/*
 * Cart drawer — "Recommended products" Swiper.
 *
 * The cart drawer re-renders its whole `.drawer__inner` on every cart update
 * (quantity change, remove, add-to-cart, open). Inline <script> tags inside
 * injected innerHTML do NOT execute, so we init from this global asset and
 * re-init whenever the drawer subtree changes (MutationObserver). The
 * `el.swiper` guard keeps init idempotent — a fresh DOM node has no instance,
 * an already-initialized one is skipped.
 */
(function () {
  function initCartRecommendedSwiper() {
    if (typeof Swiper === 'undefined') return;
    var el = document.querySelector('.cart-recommended-swiper');
    if (!el || el.swiper) return;

    var scope = el.closest('.cart_frequently_bought_section') || el.parentNode;

    // eslint-disable-next-line no-new
    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: scope.querySelector('.cart-recommended-next'),
        prevEl: scope.querySelector('.cart-recommended-prev'),
      },
      pagination: {
        el: scope.querySelector('.cart-recommended-pagination'),
        clickable: true,
      },
    });
  }

  function getDrawer() {
    return document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
  }

  function start() {
    initCartRecommendedSwiper();

    var drawer = getDrawer();
    if (!drawer) return;

    var debounceId;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceId);
      debounceId = setTimeout(initCartRecommendedSwiper, 80);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
